'use strict';

var _ = require('lodash');
function InterlineFaresAdjustmentUploadImportModalController($scope, csvService) {
  var VALID_CLASS = 'valid';
  var INVALID_CLASS = 'invalid';
  var MAX_FILE_SIZE_IN_BYTES = 1024 * 1024 * 20;
  $scope.upload = function () {
    setScopeAtUploadStart();
    csvService.importCSV($scope.chosenFile).then(getDataAndSetUpNotifications, handleServerImportError);
  };
  $scope.handleModalHide = function () {
    reloadGridDataIfImportSuccessful();
  };
  $scope.handleModalHideAndResetItsState = function () {
    reloadGridDataIfImportSuccessful();
    restorePreviousModalState();
  };
  $scope.isUploadButtonDisabled = function () {
    return !$scope.chosenFileName || $scope.isUploadInProgress || $scope.chosenFile.size > MAX_FILE_SIZE_IN_BYTES;
  };
  restorePreviousModalState();
  function restorePreviousModalState() {
    $scope.chosenFileName = '';
    $scope.chosenFile = null;
    $scope.importedRowsStatus = '';
    $scope.importStatus = '';
    $scope.isUploadInProgress = false;
    $scope.stateToBeRestored = {
      chosenFile: null,
      chosenFileName: ''
    };
  }
  function setUpImportNotification(invalidCount, validCount) {
    if (invalidCount === 0) {
      $scope.importStatus = VALID_CLASS;
      $scope.importedRowsStatus = '' + validCount + ' records were imported successfully';
    } else {
      $scope.isImportValidationError = true;
      $scope.importedRowsStatus = '' + (validCount + invalidCount) + ' records were imported with ' + invalidCount + ' errors';
      $scope.importStatus = INVALID_CLASS;
    }
    $scope.isUploadInProgress = false;
  }
  function getDataAndSetUpNotifications(response) {
    var allRows = response.value;
    var invalidCount = _.sumBy(allRows, function (row) {
      return !row.valid ? 1 : 0;
    });
    var validCount = _.sumBy(allRows, function (row) {
      return row.valid ? 1 : 0;
    });
    setUpImportNotification(invalidCount, validCount, allRows);
  }
  function handleServerImportError() {
    $scope.isUploadInProgress = false;
  }
  function setScopeAtUploadStart() {
    $scope.importedRowsStatus = '';
    $scope.importStatus = '';
    $scope.isImportValidationError = false;
    $scope.isUploadInProgress = true;
  }
  function reloadGridDataIfImportSuccessful() {
    if ($scope.importStatus === VALID_CLASS) {
      $scope.$broadcast('grid:dataChanged');
    }
  }
}
InterlineFaresAdjustmentUploadImportModalController.$inject = ['$scope', 'InterlineFaresAdjustmentCSVService'];
module.exports = InterlineFaresAdjustmentUploadImportModalController;